import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const Login = () => {
    const { login } = useAuth();
    const [form, setForm] = useState({ identifier: "", password: "" });
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");
    
    const validate = () => {
        const errs = {};
        if (!form.identifier) {
            errs.identifier = "Identifier (email or username) is required";
        }
        if (!form.password) {
            errs.password = "Password is required";
        }
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };
    
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setApiError("");
        if (!validate()) return;
        
        try {
            await login(form.identifier, form.password);
            // The login function in AuthContext should handle redirect or state updates
        } catch (error) {
            setApiError(
                error.response?.data?.message || "Login failed. Please try again."
            );
        }
    };
    
    return (
        <div className="container mt-5" style={{ maxWidth: "400px" }}>
            <h2 className="mb-4 text-center">Login</h2>
            {apiError && (
                <div className="alert alert-danger" role="alert">
                    {apiError}
                </div>
            )}
            <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                    <label htmlFor="identifier" className="form-label">
                        Email or Username
                    </label>
                    <input
                        type="text"
                        className={`form-control ${errors.identifier ? "is-invalid" : ""}`}
                        id="identifier"
                        name="identifier"
                        value={form.identifier}
                        onChange={handleChange}
                        placeholder="Enter your email or username"
                    />
                    {errors.identifier && (
                        <div className="invalid-feedback">{errors.identifier}</div>
                    )}
                </div>
                
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                        Password
                    </label>
                    <input
                        type="password"
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                        id="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                    />
                    {errors.password && (
                        <div className="invalid-feedback">{errors.password}</div>
                    )}
                </div>
                
                <button type="submit" className="btn btn-primary w-100">
                    Login
                </button>
            </form>
        </div>
    );
};

export default Login;
